import { z } from "zod";

export const BulkUploadDataRequestBodySchema = z.object({
  start: z.number(),
  end: z.number(),
});

export type BulkUploadDataRequestBodyType = z.infer<
  typeof BulkUploadDataRequestBodySchema
>;
